import { AbstractControl } from '@angular/forms';

export function selectedFromListValidator(
  control: AbstractControl,
  idField = 'id',
): boolean {
  const value = control.value;

  return !!(value && typeof value === 'object' && value[idField]);
}
